module.exports = __webpack_public_path__ + "img/armhole length front.2b113126.png";